import React from "react";

export default function AboutPage() {
  return (
    <>
      {/* ⭐ INLINE PREMIUM CSS */}
      <style>{`
        .about-banner {
          height: 330px;
          background: url('/about-img.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
        }

        .about-banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .about-banner h1 {
          z-index: 2;
          font-size: 50px;
          font-weight: 800;
          animation: fadeUp 1s ease;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.85);
          padding: 40px;
          border-radius: 20px;
          backdrop-filter: blur(10px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.10);
          border: 1px solid rgba(0,0,0,0.07);
          animation: fadeUp 1s ease;
        }

        .about-title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 18px;
          position: relative;
        }

        .about-title::after {
          content: "";
          width: 90px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #ff3b3b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .about-text {
          font-size: 17px;
          line-height: 1.75;
          color: #444;
        }

        .stats-box {
          background: #eef4ff;
          padding: 30px;
          border-radius: 16px;
          box-shadow: 0 12px 30px rgba(0,0,0,0.10);
          text-align: center;
        }

        .stats-number {
          font-size: 38px;
          font-weight: 900;
          color: #005eff;
        }

        .stats-label {
          font-size: 16px;
          font-weight: 600;
          margin-top: 8px;
        }

        .why-box {
          background: white;
          padding: 22px;
          border-radius: 15px;
          border-left: 6px solid #005eff;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          margin-bottom: 18px;
          animation: fadeUp 1s ease;
        }

        .why-box h5 {
          margin: 0;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 17px;
        }

        .why-box i {
          font-size: 22px;
          color: #005eff;
        }

        ul.compliance-list li {
          margin-bottom: 10px;
          font-size: 16px;
          color: #444;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="about-banner">
        <h1>About SWIFTSHIP</h1>
      </div>

      {/* ⭐ SECTION 1 — Corporate Overview */}
      <section className="section">
        <div className="container">
          <div className="glass-card">
            <h2 className="about-title">Who We Are</h2>

            <p className="about-text">
              SWIFTSHIP LLC is a registered logistics & supply-chain service provider based in Phoenix,
              Arizona. We specialize in domestic shipping, international freight forwarding, e-commerce
              fulfillment, and warehousing solutions designed for businesses that require reliability,
              transparency, and compliance-focused operations.
            </p>

            <p className="about-text mt-3">
              Our services are structured to meet modern U.S. logistics standards —
              ensuring accurate handling, verified shipments, clean documentation, and seamless delivery.
              Every part of our workflow is designed to protect customers, operate transparently, and
              maintain strong relationships with carriers, vendors, and payment partners.
            </p>
          </div>
        </div>
      </section>

      {/* ⭐ SECTION 2 — Compliance & Operational Integrity */}
      <section className="section" style={{ background: "#f7faff" }}>
        <div className="container">
          <div className="glass-card">
            <h2 className="about-title">Our Compliance Commitment</h2>

            <p className="about-text">
              As a U.S.-based logistics company, SWIFTSHIP follows strict operational, financial,
              and regulatory standards that support secure and responsible shipping services.
            </p>

            <ul className="compliance-list mt-3">
              <li>• Compliance with U.S. Customs & Border Protection (CBP) guidelines</li>
              <li>• Accurate import/export documentation & shipment verification</li>
              <li>• Ethical handling of packages and transparent communication</li>
              <li>• Secure data practices following modern privacy obligations</li>
              <li>• Clear pricing and no misleading representations</li>
            </ul>

            <p className="about-text mt-3">
              Our compliance-first workflow establishes trust with customers, financial institutions,
              and payment processors — ensuring smooth operations without unnecessary risk.
            </p>
          </div>
        </div>
      </section>

      {/* ⭐ SECTION 3 — Numbers */}
      <section className="section">
        <div className="container text-center">
          <h2 className="about-title text-center mb-5">Our Strength in Numbers</h2>

          <div className="row g-4">
            <div className="col-md-3">
              <div className="stats-box">
                <div className="stats-number">10K+</div>
                <div className="stats-label">Shipments Completed</div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stats-box">
                <div className="stats-number">5K+</div>
                <div className="stats-label">Business Clients Served</div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stats-box">
                <div className="stats-number">50+</div>
                <div className="stats-label">Carrier Partners</div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stats-box">
                <div className="stats-number">7+</div>
                <div className="stats-label">Years in Service</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ⭐ SECTION 4 — Why Choose Us */}
      <section className="section" style={{ background: "#f1f6ff" }}>
        <div className="container">
          <h2 className="about-title text-center mb-5">Why Businesses Choose SWIFTSHIP</h2>

          <div className="row">
            <div className="col-md-6">
              <div className="why-box">
                <h5><i className="bi bi-shield-check"></i> Verified & Responsible Operations</h5>
              </div>
              <div className="why-box">
                <h5><i className="bi bi-clock-history"></i> Reliable Pickup & Delivery Timelines</h5>
              </div>
              <div className="why-box">
                <h5><i className="bi bi-headset"></i> Clear, Consistent Customer Support</h5>
              </div>
            </div>

            <div className="col-md-6">
              <div className="why-box">
                <h5><i className="bi bi-globe2"></i> Domestic & International Capabilities</h5>
              </div>
              <div className="why-box">
                <h5><i className="bi bi-cash-stack"></i> Predictable, Transparent Rates</h5>
              </div>
              <div className="why-box">
                <h5><i className="bi bi-bar-chart"></i> Technology-Enhanced Tracking</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ⭐ FINAL CTA */}
      <section className="section text-center">
        <div className="container">
          <h2 className="about-title">Ready to Partner with SWIFTSHIP?</h2>
          <p className="about-text mt-2" style={{ maxWidth: "780px", margin: "auto" }}>
            Our team is committed to delivering secure, compliant, and dependable logistics solutions
            for businesses across the U.S. and beyond.
          </p>

          <button className="btn btn-primary px-4 py-2 mt-3">Get Started →</button>
        </div>
      </section>
    </>
  );
}
